import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-gray-600 text-sm border-t mt-10">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center">
        <p>&copy; {new Date().getFullYear()} NeedRadar. All rights reserved.</p>
        <div className="flex space-x-4 mt-2 md:mt-0">
          <a href="/terms" className="hover:underline">利用規約</a>
          <a href="/privacy" className="hover:underline">プライバシー</a>
          <a href="/contact" className="hover:underline">お問い合わせ</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
